<div class="radio-button-component" [ngClass]="{'likert-chart': formItem.item.iconName==8}">

  <div class="row">
    <div class="col">
      <h5 class="title" [ngClass]="{'required': isRequired}">{{getLabelFormTitle()}}<!--<i class="bi bi-exclamation-circle exclamation-cirle-red"></i>--></h5>
      <app-audioplayer *ngIf="formItem?.item?.allowAudio && formItem?.item?.audioFileName != '' && formItem.item?.audioFileName != null " [formItem]="formItem" [formId]="formId"></app-audioplayer>
    </div>
    </div>


  <div class="row options optionsStyle" *ngIf="formItem.item.iconName==5" >

    <div [ngClass]="classRbtn" *ngFor="let option of radioOptions; let isLast = last" >
      <input [id]="formItem.id + option.keydsi" [value]="option.keydsi" [name]="formItem.id" ngModel [(ngModel)]="formItem.value"
        #validationForm="ngModel" (change)="updateConditional()" [required]="isRequired" type="radio">
      <label [for]="formItem.id + option.keydsi" class="label-radiobutton-survey optionslabel" > {{getLabel(option)}}</label>
    </div>
  </div>

  <div class="row options" *ngIf="formItem.item.iconName==6" id="optionsThermometer">
    <div class="thermometer horizontal">
      <div class="option-wrapper">
        <div class="thermometer-container">
          <div class="thermometer-inner">
            <div class="thermometer-images">
              <img src="../../../../assets/images/thv-bg.png" class="image-back-thermometer" />
              <div class="image-top-mask" [style.width.px]="widthThermometer">
                <img src="../../../../assets/images/thv-top-red.png"  (load)="updateMaskLength()" class="image-top-thermometer" />
              </div>
            </div>
            <nouislider id="sliderThermometer" [config]="sliderConfig" [(ngModel)]="valueThermometer" (change)="updateConditional()" class="thermometerClass">
            </nouislider>
            <div class="labelThermometer">
              <p id="label1"><strong>{{label1}}</strong></p>
              <p id="label10"><strong>{{label10}}</strong></p>
            </div>
            <p class="thermometer-label" [style.margin-left.px]="marginLabel">
              {{valueThermometer}}
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>


  <div class="row options" *ngIf="formItem.item.iconName==6" id="optionsThermometer2">
    <div class="thermometer horizontal">
      <div class="option-wrapper">
        <div class="thermometer-container">
          <div class="thermometer-inner">

            <nouislider id="sliderThermometerMobile" [config]="sliderConfigMobile" [(ngModel)]="valueThermometer" (change)="updateConditional()" class="thermometerClassMobile">
            </nouislider>
            <div>
              <div class="thermometer-label2">
                Your selection:
                <div class="valueThermometerLabel">
                  {{valueThermometer}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="custom-controls-stacked" *ngIf="formItem.item.iconName!=5 && formItem.item.iconName!=8 && formItem.item.iconName!=6">

    <div *ngFor="let option of radioOptions; let isLast = last" class="content-radio">

      <label class="">
        <span class="">
          <input [id]="formItem.id + option.keydsi" [value]="option.keydsi" [name]="formItem.id" ngModel [(ngModel)]="formItem.value"
            #validationForm="ngModel" (change)="updateConditional()" [required]="isRequired" type="radio" class="custom-control-input">

          <i *ngIf="formItem.item.iconName==1" class="bi bi-circle"></i><i *ngIf="formItem.item.iconName==1" class="bi bi-record-circle csc-primary-color"></i>
          <i *ngIf="formItem.item.iconName==2" class="bi bi-check"></i><i *ngIf="formItem.item.iconName==2" class="bi bi-check-square csc-primary-color"></i>
          <i *ngIf="formItem.item.iconName==3" class="bi bi-star"></i><i *ngIf="formItem.item.iconName==3" class="bi bi-star-fill csc-primary-color"></i>
          <i *ngIf="formItem.item.iconName==4" class="bi bi-hand-thumbs-up"></i><i *ngIf="formItem.item.iconName==4" class="bi bi-hand-thumbs-up-fill csc-primary-color"></i>
          <span class="custom-control-description csc-font-family">{{getLabel(option)}}</span>
        </span>

      </label>

      <ng-container *ngIf="isLast && validationForm.INVALID">
        <br />
        <small class="incorrect-field">
          This field is required
        </small>
      </ng-container>

    </div>
  </div>

  <div class="custom-controls-stacked likert-chart" *ngIf="formItem.item.iconName==8" id="optionsChart">
    <div class="row options-pediatric">
      <div class="col-xs-2 option-wrapper op-pediatric"  *ngFor="let option of radioOptions; let isLast = last">
        <div *ngIf="option.orderdsi > 0 && option.orderdsi < 6">
          <label>
              <input type="radio" name="radio{{formItem.item.id}}" [value]="option.keydsi" [(ngModel)]="formItem.value" (change)="updateConditional()"  #validationForm="ngModel" [required]="isRequired"/>
              <img class="likert-five" [src]="'../../../../assets/images/pediatric-likert-five-'+option.orderdsi+'.png'"/>
            </label>
          <p class="labelField csc-font-family">{{option.labelField}}</p>
        </div>
      </div>
      <ng-container *ngIf="isLast && validationForm.INVALID">
        <br />
        <small class="incorrect-field">
          This field is required
        </small>
      </ng-container>
    </div>
  </div>
</div>
